<template>
  <div>
    <span v-if="status == 1" class="badge bdg-draft">Draft</span>
    <span v-if="status == 2" class="badge bdg-new">New Deal</span>
    <span v-if="status == 3" class="badge bdg-amended">Amended Deal</span>
    <span v-if="status == 4" class="badge bdg-processing">Processing</span>
    <span v-if="status == 5" class="badge bdg-approved">Approved</span>
    <span v-if="status == 6" class="badge bdg-settled">Settled</span>
    <span v-if="status == 7" class="badge bdg-not-proceeding">Archived</span>
    <span v-if="status == 8" class="badge bdg-not-assist">Can not Assist</span>
    <span v-if="status == 9" class="badge bdg-doc-to-client"
      >Doc's To Client</span
    >
    <span v-if="status == 10" class="badge bdg-doc-to-employer"
      >Doc's To Employer</span
    >
    <span v-if="status == 11" class="badge bdg-doc-to-settlement"
      >Doc's to Settlement</span
    >
    <span v-if="status == 12" class="badge bdg-pending-ds"
      >Pending Delivery</span
    >
    <span v-if="status == 13" class="badge bdg-pending-application"
      >Pending Application</span
    >
    <span v-if="status == 14" class="badge bdg-pending-doc"
      >Preparing Docs</span
    >
  </div>
</template>
<script>
export default {
  name: 'WDQuoteStatusBadge',
  props: ['status']
}
</script>
